import { useEffect, useState } from 'react'

type TimeLeft = {
  hours: string
  minutes: string
  seconds: string
  isExpired: boolean
}

function endOfToday(): number {
  const end = new Date()
  end.setHours(23, 59, 59, 999)
  return end.getTime()
}

function format(ms: number): TimeLeft {
  if (ms <= 0) {
    return { hours: '00', minutes: '00', seconds: '00', isExpired: true }
  }
  const totalSeconds = Math.floor(ms / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
    isExpired: false,
  }
}

export function useCountdown(): TimeLeft {
  const [target] = useState(endOfToday)
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() => format(target - Date.now()))

  useEffect(() => {
    const id = window.setInterval(() => {
      setTimeLeft(format(target - Date.now()))
    }, 1000)
    return () => window.clearInterval(id)
  }, [target])

  return timeLeft
}
